import { Injectable } from "@angular/core";
import { AbstractAdapter, Adapter, IAdapter } from "@app/utils/types";
import { OrganizationViewModel, IOrganizationDTO } from "@app/models/organization.model";

@Injectable({
  providedIn: "root",
})
@Adapter({ classRef: OrganizationViewModel })
export class OrganizationAdapter
  extends AbstractAdapter<IOrganizationDTO, OrganizationViewModel>
  implements IAdapter<IOrganizationDTO, OrganizationViewModel> {}
